import { useCallback, useEffect, useState } from 'react'
import { ToastNotifications } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { useQuickKeysManager, useSyncManager } from '../../ng-compat/hooks'
import { ApiLayoutData } from './utils/qk-types'

export const useQuickKeyData = (id: string) => {
  const t = useT()
  const quickKeysManager = useQuickKeysManager()
  const syncManager = useSyncManager()
  const [data, setData] = useState<ApiLayoutData | null>(null)

  useEffect(() => {
    const setLayout = async () => {
      await quickKeysManager.init()
      // There are two inconsistent definitions of the layout types
      // one in webregister and another in vend-types. The webregister
      // version is narrower but correct.
      const layout = (await quickKeysManager.getQuickKeyLayoutById(
        id
      )) as ApiLayoutData | null
      setData(layout || null)
    }

    setLayout()
  }, [id, quickKeysManager])

  const handleError = useCallback(async () => {
    ToastNotifications.negative(
      t(
        'There was an error making that change, please wait while we refresh your quick keys.'
      )
    )
    setData(null)
    await syncManager.sync()
    const layout = (await quickKeysManager.getQuickKeyLayoutById(
      id
    )) as ApiLayoutData | null
    setData(layout || null)
  }, [id, quickKeysManager, syncManager, t])

  return [data, setData, handleError] as const
}
